import React, { useEffect, useState } from "react";
import {
  Grid,
  MenuItem,
  TextField,
  CircularProgress,
  Button,
} from "@mui/material";
import "./Reports.css";
import { isEmpty } from "../../app/utils";

const ApplicationStatusReport = () => {
  const [formValues, setFormValues] = useState({});
  //use effects

  //methods
  const isBusy = () => {
    return false;
  };

  const handleSubmit = () => {};

  //builders
  const BuildForm = () => {
    return (
      <div className="report-form-bg">
        <Grid container>
          <Grid item md={3} sm={4} xs={6} className="padded-grid-item">
            <TextField
              variant="outlined"
              label="Start Date"
              InputLabelProps={{ shrink: true }}
              margin="dense"
              fullWidth
              type="date"
              value={formValues?.startDate}
              InputProps={{
                inputProps: {
                  max: new Date().toISOString().split("T")[0] ?? "",
                },
              }}
              onChange={(event) => {
                setFormValues({ ...formValues, startDate: event.target.value });
              }}
            />
          </Grid>
          <Grid item md={3} sm={4} xs={6} className="padded-grid-item">
            <TextField
              variant="outlined"
              margin="dense"
              fullWidth
              label="End Date"
              type="date"
              InputLabelProps={{ shrink: true }}
              value={formValues?.endDate}
              InputProps={{
                inputProps: {
                  max: new Date().toISOString().split("T")[0] ?? "",
                },
              }}
              onChange={(event) => {
                setFormValues({ ...formValues, endDate: event.target.value });
              }}
            />
          </Grid>
          <Grid item md={3} sm={4} xs={6} className="padded-grid-item">
            <div style={{ marginTop: "8px" }}>
              <Button
                className="btn-login"
                variant="contained"
                onClick={handleSubmit()}
                margin="dense"
                size="medium"
                color="primary"
                disabled={
                  isBusy() ||
                  isEmpty(formValues?.startDate) ||
                  isEmpty(formValues?.endDate)
                }
                style={{ textTransform: "unset" }}
              >
                {isBusy() && (
                  <CircularProgress
                    size={20}
                    color="primary"
                    style={{ marginRight: "8px" }}
                  />
                )}
                Run Report
              </Button>
            </div>
          </Grid>
        </Grid>
      </div>
    );
  };

  return <>{BuildForm()}</>;
};

export default ApplicationStatusReport;
